import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { classNames } from '@pella/sash-framework/dist/utilities';
import { Image, CTA } from '../..';

const ProductHero = ({ data, isPDP = false, className, ...other }) => {
	if (!data) return null;

	const isWideImage = data?.image?.[0]?.file?.gatsbyImageData?.width >= 382;

	const classes = classNames({
		'productHero grid grid-cols-[24px_1fr_24px] grid-rows-[repeat(4,minmax(min-content,max-content))] md:grid-rows-[repeat(3,minmax(min-content,max-content))]': true,
		'md:grid-cols-[32px_1fr_32px] xl:grid-cols-[1fr_64px_minmax(1024px,1440px)_64px_1fr]': !data?.image?.[0], // no image
		'md:grid-cols-[32px_1fr_40px_272px_32px] xl:grid-cols-[1fr_64px_minmax(757px,1070px)_80px_290px_64px_1fr]': data.image?.[0] && !isWideImage, //vertical
		'md:grid-cols-[32px_1fr_40px_355px_32px] xl:grid-cols-[1fr_64px_minmax(757px,918px)_80px_442px_64px_1fr]': data.image?.[0] && isWideImage, // horizontal
		[className]: className,
	});

	return (
		<div
			className={classes}
			{...other}
		>
			<div
				className='productHero-bg col-span-full col-start-1 row-start-1 row-end-4 md:row-end-3'
				style={{ backgroundColor: data.background_hex_value }}
			/>

			<div className='productHero-heading relative col-start-2 row-start-1 py-4 md:col-end-4 md:pt-6 xl:col-start-3 xl:col-end-3 xl:pt-8'>
				<h1 className='m-0'>
					{data.subheading && <span className='mb-1 block text-sm font-bold uppercase !leading-none tracking-3px text-white md:text-base xl:text-xl'>{data.subheading}</span>}
					{data.heading && <span className='block font-normal !leading-[1.2] text-white xl:text-5xl'>{data.heading}</span>}
					{data.impact_non && <span className='mt-1 block text-sm font-bold uppercase !leading-[1.2] tracking-3px text-white xl:text-base'>{data.impact_non}</span>}
				</h1>
			</div>

			<div className='productHero-desc relative col-start-2 row-start-2 pb-4 md:pb-6 xl:col-start-3 xl:pb-8'>
				{data.description && (
					<div
						className='text-sm text-white xl:text-xl'
						dangerouslySetInnerHTML={{ __html: data.description }}
					/>
				)}

				{data.cta?.[0] && (
					<List
						bullets='none'
						className='productHero-cta mt-4 space-y-3 xl:flex xl:flex-wrap xl:space-x-3 xl:space-y-0'
					>
						{data.cta.map((cta, index) => (
							<li
								className='flex-12/12 xl:flex-none'
								key={index}
							>
								<CTA
									data={cta}
									className='h-full'
									wide
								/>
							</li>
						))}
					</List>
				)}
			</div>

			{data.image?.[0] && (
				<div className='productHero-image relative col-start-2 row-start-3 row-end-5 pt-4 text-center md:col-start-4 md:row-start-2 md:pt-0 xl:col-start-5 xl:row-start-1 xl:row-end-4'>
					<div className={`mx-auto xl:mt-10 ${!isWideImage ? 'max-md:w-40' : ''}  ${isPDP ? 'bg-white p-5 md:absolute md:left-0 md:top-0 xl:p-8' : ''}`}>
						<Image
							data={data.image[0]}
							loading='eager'
						/>
					</div>
				</div>
			)}
		</div>
	);
};

ProductHero.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
	isPDP: PropTypes.bool,
};

export default ProductHero;
